var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDev)?_c('button-link',{staticStyle:{"color":"red","font-weight":"bolder"},attrs:{"to":"/test/test"}},[_vm._v("\n  TEST\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }